import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const DELIVERABLES = [
  { icon: 'ri-advertisement-line', key: 'del1' },
  { icon: 'ri-edit-2-line', key: 'del2' },
  { icon: 'ri-share-line', key: 'del3' },
  { icon: 'ri-image-2-line', key: 'del4' },
  { icon: 'ri-settings-3-line', key: 'del5' },
  { icon: 'ri-bar-chart-grouped-line', key: 'del6' },
  { icon: 'ri-lightbulb-flash-line', key: 'del7' },
  { icon: 'ri-file-chart-2-line', key: 'del10' },
];

export default function MonthlyDeliverables() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#F7F8FA] text-[#E53935] text-xs font-semibold tracking-wider uppercase mb-5 border border-gray-100">
              {t('trafficMaster.monthlyTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111111] leading-tight">
              {t('trafficMaster.monthlyTitle')}
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {DELIVERABLES.map((item, i) => (
            <ScrollReveal key={item.key} delay={i * 0.06}>
              <div className="group bg-[#F7F8FA] hover:bg-white rounded-2xl p-6 border border-gray-100 hover:border-[#C8A24A]/30 hover:shadow-[0_8px_40px_rgba(0,0,0,0.05)] transition-all duration-400 flex flex-col items-center text-center cursor-pointer h-full">
                <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-4 group-hover:bg-[#C8A24A]/5 transition-colors duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.03)]">
                  <i className={`${item.icon} text-[#E53935] text-xl`}></i>
                </div>
                <span className="text-[#111111] text-sm font-semibold">
                  {t(`trafficMaster.${item.key}`)}
                </span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}